var _rect, _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgAmexIcon = function SvgAmexIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.25,
    width: 23.5,
    height: 15.5,
    rx: 2.25,
    fill: "#1F72CD",
    stroke: "#DFDFDF",
    strokeWidth: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m4.478 5.62-2.145 4.956H4.9l.319-.79h.727l.318.79H9.09v-.603l.252.603h1.461l.252-.616v.616h5.877l.714-.77.67.77 3.017.006-2.15-2.47 2.15-2.492h-2.971l-.696.756-.648-.756h-6.393l-.548 1.28-.562-1.28H6.953v.583l-.285-.583h-2.19Zm8.775.704h3.374l1.033 1.164 1.065-1.164h1.032l-1.568 1.787 1.568 1.767h-1.079L17.646 8.7l-1.07 1.178h-3.323V6.324Zm.833 1.386v-.65h2.106l.919 1.038-.96 1.044h-2.065v-.709h1.841V7.71h-1.84ZM4.974 6.324h1.252l1.422 3.36v-3.36h1.37l1.1 2.41 1.012-2.41h1.364V9.88h-.83l-.007-2.786-1.21 2.786h-.742L8.488 7.094V9.88H6.781l-.324-.797H4.708l-.323.796h-.914l1.503-3.555Zm.033 2.022.576-1.42.575 1.42H5.007Z",
    fill: "#fff"
  })));
};

export default SvgAmexIcon;